import { SET_ACCOUNT_DATA } from '../actions/types';

export default function accountData(state = {}, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_ACCOUNT_DATA:
				return action.payload;
			// no default
		}
	}

	return state;
}
